import { IntegrationViewFragment } from 'generated/graphql';

export const mapConnectedIntegrationToWorkspaces = (
  integrations: IntegrationViewFragment[],
) => {
  return integrations
    .sort((a, b) => a.createdAt - b.createdAt)
    .map((integration, index) => ({
      id: integration.id,
      name:
        integration.externalID ||
        `${integration.channel.displayName} ${index + 1}`,
    }));
};
